// Do not log request bodies, customer details, tokens or provider error payloads.
export const reportError = (operation, error) => {
  if (error?.name === "AbortError" || error?.code === "ERR_CANCELED") return;
  console.warn(`[Evi-Studio] ${operation}`, {
    type: error?.name || "Error",
    status: error?.response?.status,
  });
};